module.exports = __webpack_public_path__ + "img/main.1c50873b.png";